import { ActionReducerMap } from "@ngrx/store";
import { authenticationReducer } from "./Authentication/authentication.reducer";
import { LayoutState, layoutReducer } from "./layouts/layouts.reducer";
import { AuthenticationState } from "./Authentication/auth.models";
import { profileReducer } from "./Profile/profile.reducer";
import { roleRecordReducer, RoleRecordsState } from "./Roles/roles.reducer";
import { manualsRecordReducer, ManualsRecordsState } from "./Manuals/manuals.reducer";
import { changelogsRecordReducer, ChangelogsRecordsState } from "./Changelogs/changelogs.reducer";
import { faqsRecordReducer, FaqsRecordsState } from "./Faqs/faqs.reducer";
import { SupportRequestRecordsState, supportRequestsRecordReducer } from "./SupportRequests/support-requests.reducer";
import { clubRecordReducer, ClubRecordsState } from "./Clubs/clubs.reducer";
import { clubUserRecordReducer, ClubUserRecordsState } from "./ClubUser/club-user.reducer";
import { changelogVersionsRecordReducer, ChangelogVersionsRecordsState } from "./ChangelogVersions/changelog-versions.reducer";
import { userRecordReducer, UserRecordsState } from "./Users/users.reducer";
import { clubNoteRecordReducer, ClubNoteRecordsState } from "./ClubNotes/club-notes.reducer";
import { clubAttachmentRecordReducer, ClubAttachmentRecordsState } from "./ClubAttachment/club-attachment.reducer";
import { ClubManagementRecordsState, clubManagementReducer } from "./ClubManagement/club-management.reducer";
import { TaskCategoryRecordReducer, TaskCategoryRecordsState } from "./TaskCategory/task-category.reducer";
import { clubLogRecordReducer, ClubLogsRecordsState } from "./ClubLogs/club-logs.reducer";
import { DashboardRecordReducer, DashboardRecordsState } from "./Dashboard/dashboard.reducer";
import { DossierRecordReducer, DossierRecordsState } from "./Dossier/dossier.reducer";
import { dossierAttachmentRecordReducer, DossierAttachmentRecordsState } from "./DossierAttachment/dossier-attachment.reducer";
import { CommunicationCategoryRecordReducer, CommunicationCategoryRecordsState } from "./CommunicationCategory/communication-category.reducer";
import { AgendaTaskRecordsState, agendaTaskReducer } from "./AgendaTask/agenda-task.reducer";
import { dossierLogRecordReducer, DossierLogsRecordsState } from "./DossierLogs/dossier-logs.reducer";
import { DossierCategoryRecordReducer, DossierCategoryRecordsState } from "./DossierCategory/dossier-category.reducer";
import { dossierNoteRecordReducer, DossierNoteRecordsState } from "./DossierNotes/dossier-notes.reducer";
import { SentEmailsRecordReducer, SentEmailsRecordsState } from "./SentEmails/sent-emails.reducer";
import { SentCorrespondencesRecordReducer, SentCorrespondencesRecordsState } from "./SentCorrespondence/sent-correspondence.reducer";
import { EmailTemplateRecordReducer, EmailTemplateRecordsState } from "./EmailTemplate/email-template.reducer";
import { WhatsappTemplateRecordReducer, WhatsappTemplateRecordsState } from "./WhatsappTemplate/whatsapp-template.reducer";
import { SmsTemplateRecordReducer, SmsTemplateRecordsState } from "./SmsTemplate/sms-template.reducer";
import { LetterTemplateRecordReducer, LetterTemplateRecordsState } from "./LetterTemplate/letter-template.reducer";
import { SeasonsRecordReducer, SeasonsRecordsState } from "./Seasons/seasons.reducer";
import { MemberRecordReducer, MemberRecordsState } from "./Member/member.reducer";
import { memberAttachmentRecordReducer, MemberAttachmentRecordsState } from "./MemberAttachment/member-attachment.reducer";
import { memberNoteRecordReducer, MemberNoteRecordsState } from "./MemberNotes/member-notes.reducer";
import { memberLogRecordReducer, MemberLogsRecordsState } from "./MemberLogs/member-logs.reducer";
import { WorkflowRestrictionsRecordReducer, WorkflowRestrictionsRecordsState } from "./WorkflowRestrictions/workflow-restrictions.reducer";
import { WorkflowSettingsRecordReducer, WorkflowSettingsRecordsState } from "./WorkflowSettings/workflow-settings.reducer";
import { WorkflowEmailTemplateRecordReducer, WorkflowEmailTemplateRecordsState } from "./WorkflowEmailTemplate/workflow-email-template.reducer";
import { WorkflowsRecordReducer, WorkflowsRecordsState } from "./Workflows/workflows.reducer";
import { ClubCategoryRecordReducer, ClubCategoryRecordsState } from "./ClubCategory/club-category.reducer";
import { DossierWorkflowRecordReducer, DossierWorkflowRecordsState } from "./DossierWorkflow/dossier-workflow.reducer";
import { ReportRecordReducer, ReportRecordsState } from "./Report/report.reducer";
import { DossierInvoicesRecordReducer, DossierInvoicesRecordsState } from "./DossierInvoice/dossier-invoice.reducer";
import { BulkToolsRecordReducer, BulkToolsRecordsState } from "./BulkTools/bulk-tools.reducer";
import { ServiceFeeRecordReducer, ServiceFeeRecordsState } from "./ServiceFee/service-fee.reducer";
import { PrintlogsRecordReducer, PrintlogsRecordsState } from "./Printlogs/printlogs.reducer";
import { BulkImportRecordReducer, BulkImportRecordsState } from "./BulkImport/bulk-import.reducer";
import { PaymentTypeRecordReducer, PaymentTypeRecordsState } from "./PaymentType/payment-type.reducer";
import { UserNotificationsRecordReducer, UserNotificationsRecordsState } from "./UserNotifications/user-notifications.reducer";
import { ContributieEmailTemplateRecordReducer, ContributieEmailTemplateRecordsState } from "./ContributieEmailTemplate/contributie-email-template.reducer";
import { PaymentArrangementRecordReducer, PaymentArrangementRecordsState } from "./PaymentArrangement/payment-arrangement.reducer";
import { WorkflowLetterTemplateRecordReducer, WorkflowLetterTemplateRecordsState } from "./WorkflowLetterTemplate/workflow-letter-template.reducer";
import { WorkflowFailedEmailRecordReducer, WorkflowFailedEmailRecordsState } from "./WorkflowFailedEmail/workflow-failed-email.reducer";
import { FailedEmailsRecordReducer, FailedEmailsRecordsState } from "./FailedEmails/failed-emails.reducer";
import { SportlinkRecordReducer, SportlinkRecordsState } from "./Sportlink/sportlink.reducer";

export interface RootReducerState {
    layout: LayoutState;
    auth: AuthenticationState;
    profile: AuthenticationState;
    rolesList: RoleRecordsState;
    manualsRecords: ManualsRecordsState;
    changelogsRecords: ChangelogsRecordsState;
    faqsRecords: FaqsRecordsState;
    supportRequestRecords: SupportRequestRecordsState;
    clubRecords: ClubRecordsState;
    clubNoteRecords: ClubNoteRecordsState;
    clubUserRecords: ClubUserRecordsState;
    changelogVersionsRecords: ChangelogVersionsRecordsState;
    userRecords: UserRecordsState;
    clubAttachmentRecords: ClubAttachmentRecordsState;
    clubManagementRecords: ClubManagementRecordsState;
    taskCategoryRecords: TaskCategoryRecordsState;
    clubLogRecords: ClubLogsRecordsState;
    dashboardRecords: DashboardRecordsState;
    dossierRecords: DossierRecordsState;
    dossierAttachmentRecords: DossierAttachmentRecordsState;
    communicationCategoryRecords: CommunicationCategoryRecordsState;
    agendaTaskRecords: AgendaTaskRecordsState;
    dossierLogRecords: DossierLogsRecordsState;
    dossierCategoryRecords: DossierCategoryRecordsState;
    dossierNoteRecords: DossierNoteRecordsState;
    sentEmailsRecords: SentEmailsRecordsState;
    sentCorrespondencesRecords: SentCorrespondencesRecordsState;
    emailTemplateRecords: EmailTemplateRecordsState;
    whatsappTemplateRecords: WhatsappTemplateRecordsState;
    smsTemplateRecords: SmsTemplateRecordsState;
    letterTemplateRecords: LetterTemplateRecordsState;
    seasonsRecords: SeasonsRecordsState;
    memberRecords: MemberRecordsState;
    memberAttachmentRecords: MemberAttachmentRecordsState;
    memberNoteRecords: MemberNoteRecordsState;
    memberLogRecords: MemberLogsRecordsState;
    workflowRestrictionsRecords: WorkflowRestrictionsRecordsState;
    workflowSettingsRecords: WorkflowSettingsRecordsState;
    workflowEmailTemplateRecords: WorkflowEmailTemplateRecordsState;
    workflowsRecords: WorkflowsRecordsState;
    clubCategoryRecords: ClubCategoryRecordsState;
    dossierWorkflowRecords: DossierWorkflowRecordsState;
    reportRecords: ReportRecordsState;
    dossierInvoicesRecords: DossierInvoicesRecordsState;
    bulkToolsRecords: BulkToolsRecordsState;
    serviceFeeRecords: ServiceFeeRecordsState;
    printlogsRecords: PrintlogsRecordsState;
    bulkImportRecords: BulkImportRecordsState;
    paymentTypeRecords: PaymentTypeRecordsState;
    userNotificationsRecords: UserNotificationsRecordsState;
    contributieEmailTemplateRecords: ContributieEmailTemplateRecordsState;
    paymentArrangementRecords: PaymentArrangementRecordsState;
    workflowLetterTemplateRecords: WorkflowLetterTemplateRecordsState;
    workflowFailedEmailRecords: WorkflowFailedEmailRecordsState;
    failedEmailsRecords: FailedEmailsRecordsState;
    sportlinkRecords: SportlinkRecordsState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
    layout: layoutReducer,
    auth: authenticationReducer,
    profile: profileReducer,
    rolesList: roleRecordReducer,
    manualsRecords: manualsRecordReducer,
    changelogsRecords: changelogsRecordReducer,
    faqsRecords: faqsRecordReducer,
    supportRequestRecords: supportRequestsRecordReducer,
    clubRecords: clubRecordReducer,
    clubNoteRecords: clubNoteRecordReducer,
    clubUserRecords: clubUserRecordReducer,
    changelogVersionsRecords: changelogVersionsRecordReducer,
    userRecords: userRecordReducer,
    clubAttachmentRecords: clubAttachmentRecordReducer,
    clubManagementRecords: clubManagementReducer,
    taskCategoryRecords: TaskCategoryRecordReducer,
    clubLogRecords: clubLogRecordReducer,
    dashboardRecords: DashboardRecordReducer,
    dossierRecords: DossierRecordReducer,
    dossierAttachmentRecords: dossierAttachmentRecordReducer,
    communicationCategoryRecords: CommunicationCategoryRecordReducer,
    agendaTaskRecords: agendaTaskReducer,
    dossierLogRecords: dossierLogRecordReducer,
    dossierCategoryRecords: DossierCategoryRecordReducer,
    dossierNoteRecords: dossierNoteRecordReducer,
    sentEmailsRecords: SentEmailsRecordReducer,
    sentCorrespondencesRecords: SentCorrespondencesRecordReducer,
    emailTemplateRecords: EmailTemplateRecordReducer,
    whatsappTemplateRecords: WhatsappTemplateRecordReducer,
    smsTemplateRecords: SmsTemplateRecordReducer,
    letterTemplateRecords: LetterTemplateRecordReducer,
    seasonsRecords: SeasonsRecordReducer,
    memberRecords: MemberRecordReducer,
    memberAttachmentRecords: memberAttachmentRecordReducer,
    memberNoteRecords: memberNoteRecordReducer,
    memberLogRecords: memberLogRecordReducer,
    workflowRestrictionsRecords: WorkflowRestrictionsRecordReducer,
    workflowSettingsRecords: WorkflowSettingsRecordReducer,
    workflowEmailTemplateRecords: WorkflowEmailTemplateRecordReducer,
    workflowsRecords: WorkflowsRecordReducer,
    clubCategoryRecords: ClubCategoryRecordReducer,
    dossierWorkflowRecords: DossierWorkflowRecordReducer,
    reportRecords: ReportRecordReducer,
    dossierInvoicesRecords: DossierInvoicesRecordReducer,
    bulkToolsRecords: BulkToolsRecordReducer,
    serviceFeeRecords: ServiceFeeRecordReducer,
    printlogsRecords: PrintlogsRecordReducer,
    bulkImportRecords: BulkImportRecordReducer,
    paymentTypeRecords: PaymentTypeRecordReducer,
    userNotificationsRecords: UserNotificationsRecordReducer,
    contributieEmailTemplateRecords: ContributieEmailTemplateRecordReducer,
    paymentArrangementRecords: PaymentArrangementRecordReducer,
    workflowLetterTemplateRecords: WorkflowLetterTemplateRecordReducer,
    workflowFailedEmailRecords: WorkflowFailedEmailRecordReducer,
    failedEmailsRecords: FailedEmailsRecordReducer,
    sportlinkRecords: SportlinkRecordReducer
}